import React from 'react';
import usePlayfulTeacher from '@/hooks/usePlayfulTeacher';
import { EssayMonitoringDefault } from './Default/essay-monitoring';
import { EssayMonitoringPlayfulTeacher } from './PlayfulTeacher/essay-monitoring';

export function EssayMonitoring(props) {
  const isPlayfulTeacherTheme = usePlayfulTeacher();

  return isPlayfulTeacherTheme ? <EssayMonitoringPlayfulTeacher {...props} /> : <EssayMonitoringDefault {...props} />;
}
